import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cp-layout',
  templateUrl: './cp-layout.component.html',
  styleUrls: ['./cp-layout.component.scss'],
})
export class CpLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
